module.exports = function() {
  return new Worker(__webpack_public_path__ + "defd968560af02329b87.worker.js");
};